import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "RecentFrameworkProjects";

export const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Recent projects",
        fr: "Projets récents",
    },
    empty_state_title: {
        en: "No projects yet. Create a new one to get started.",
        fr: "Aucun projet pour le moment. Créez-en un nouveau pour commencer.",
    },
    table_header_framework: {
        en: "Framework",
        fr: "Référentiel",
    },
    table_header_name: {
        en: "Project",
        fr: "Projet",
    },
    table_header_status: {
        en: "Status",
        fr: "Statut",
    },
    table_header_last_modified: {
        en: "Last modified at",
        fr: "Dernière mise à jour",
    },
    table_header_progress: {
        en: "Completion",
        fr: "Progression",
    },
    table_header_assignees: {
        en: "Assignees",
        fr: "Assignés",
    },
});

export function useRecentFrameworkProjectsTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return {
        t,
        keys,
    };
}
